import React, { useEffect, useRef } from 'react';
import { eproScaleUrl } from '../../config/config'
import { useIframeHandle } from './useIframeHanlde'
import styles from './index.module.scss';
import { ApiCore } from '../../api/index';
import lodash from 'lodash'
import { Toast } from 'antd-mobile';


const EPROEvaluation = (props: any) => {
    const api = new ApiCore()
    const urlSearchParams = new URLSearchParams(props.location.search)
    let scaleId = (urlSearchParams.get('scaleId') || '') as string
    let scaleCode = (urlSearchParams.get('scaleCode')|| '') as string
    let scaleName = (urlSearchParams.get('scaleName')|| '') as string
    let subjectCode = (urlSearchParams.get('subjectCode')|| '') as string
    let recordId = (urlSearchParams.get('recordId') || '') as string
    let isScan= (urlSearchParams.get('isScan') || '') as string
    let arrival = urlSearchParams.get('arrival') as string === "false"? false : true

    const title = `${scaleName}（${scaleCode}）`
    useIframeHandle(new URL(eproScaleUrl).origin, (event: MessageEvent) => {
        console.log(event, 'event--------')
        let eventData: { eventName: string, recordId: number } | null = null
        try {
            eventData = JSON.parse(event.data)
        } catch (error) {
            
        }
        if (eventData?.eventName === 'scale-submit-back') {
            handleSubmitDebounce(eventData.recordId)
        }
    })

    useEffect(() => {
     
        document.title = title
    }, [])

    const iframeRef = useRef<any>(null)

    const goBack = () => {
        if(isScan){
            props.history.push('/epro/patient/home')
        }else{
            // props.history.goBack()
            props.history.push('/epro/patient/home')
        }
    }
    const handleIframeLoad = () => {
        
    }
    const handleSubmitClick = () => {
        if(!arrival){
            return Toast.fail("未到填写时间，请核查！", 1)
        }
        iframeRef?.current?.contentWindow?.postMessage?.(JSON.stringify({
            eventName: 'scale-submit',
            test: '12345678'
        }), '*')
    }
    const handleSubmit = async (recordId: number) => {
        try {
             const res = await api.saveReportScale({
                subjectCode: subjectCode,
                scaleId: Number(scaleId),
                scaleServerRecordId: recordId
            })
      
            const { code ,message} = res as any
            if (Number(code) === 0) {
                //扫码进入填写时，返回到首页。 跳转到结果页面
                if(isScan){
                    props.history.push(`/epro/patient/evaluationResult?title=${title}&scaleCode=${scaleCode}&recordId=${recordId}&isScan=${isScan}&scaleId=${scaleId}&subjectCode=${subjectCode} &`)
                }else{
                    props.history.push(`/epro/patient/evaluationResult?title=${title}&scaleCode=${scaleCode}&recordId=${recordId}&scaleId=${scaleId}&subjectCode=${subjectCode}`)
                }
            }else{
                Toast.fail(message, 1)
            }
        } catch (error) {
            
        }

    }
    const handleSubmitDebounce = lodash.debounce(handleSubmit, 200)

    return (
        <div className={styles.evaluationContainer}>
            <div className={styles.iframeContainer}>
                <iframe  ref={iframeRef} src={`${eproScaleUrl}epro/evaluation/${scaleCode}?${!arrival?'disabled=true&':''}recordId=${recordId}&abortToResult=1`} style={{height: '100%', width: '100vw', border: 'none'}} onLoad={handleIframeLoad} ></iframe>
            </div>
            <div className={arrival?styles.btnsContainer:styles.btnsContainerNo}>
                <button onClick={goBack}>返回</button>
                <button  onClick={handleSubmitClick}>完成并提交</button>
            </div>
        </div>
    )
}

export default EPROEvaluation